import Ansi from "@cocalc/ansi-to-react";
import {
  CopyToClipboard,
  cn,
  ErrorBox,
} from "@gearbox-protocol/deploy-tools-ui";
import { CodeEditor } from "components/editors";
import type { FC } from "react";
import { useAsync } from "react-use";

export interface FileContentViewProps {
  file: File;
  className?: string;
}

export const FileContentView: FC<FileContentViewProps> = ({
  file,
  className,
}) => {
  const { value, loading, error } = useAsync(() => file.text(), [file]);

  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  const isJson = ext === "json";
  const isYaml = ext === "yaml" || ext === "yml";

  if (loading) {
    return <p className={cn("text-muted-foreground", className)}>Loading...</p>;
  }

  if (error) {
    return <ErrorBox error={error} className={className} />;
  }

  const content = value ?? "";

  return (
    <div className={cn("relative", className)}>
      <div className="w-full h-full overflow-auto">
        {isJson || isYaml ? (
          <CodeEditor
            language={isJson ? "json" : "yaml"}
            value={content}
            className="w-full"
            editable={false}
          />
        ) : (
          <Ansi className="block w-full min-h-full bg-black p-2">
            {content}
          </Ansi>
        )}
      </div>

      <div className="p-1 rounded hover:bg-black/15 absolute right-4 top-1">
        <CopyToClipboard text={content} />
      </div>
    </div>
  );
};
